module.exports = __webpack_public_path__ + "img/linuxStep1.7e29ca66.png";